/**
 * 异步模块加载
 */

export enum ModuleStates {
    loading = 'loading',
    loaded = 'loaded'
};

interface ModuleState {
    state?: ModuleStates;
    resolve?: (value?: any) => void;
    reject?: (reason?: any) => void;
}

export const LoadedModules: {[key: string]: ModuleState} = Object.create(null);
/**
 * 加载 js 脚本
 * @param script
 * @param async
 */
export const loadScript = (script: string, async: boolean = true, callback?: (error?: any) => void) => {
    if (LoadedModules[script]) {
        return callback && callback(`${script} load repeat`);
    }
    const mod: ModuleState = LoadedModules[script] = {
        state: ModuleStates.loading,
    };
    const scriptEl = document.createElement('script');
    scriptEl.crossOrigin = 'anonymous';
    scriptEl.src = script;
    if (async) {
        scriptEl.async = true;
    }
    const referEl = document.getElementsByTagName('script')[0];
    if (referEl && referEl.parentNode) {
        referEl.parentNode.insertBefore(scriptEl, referEl);
    } else {
        document.head.appendChild(scriptEl);
    }

    scriptEl.onload = () => {
        mod.state = ModuleStates.loaded;
        callback && callback();
    };
    scriptEl.onerror = (e) => {
        mod.state = ModuleStates.loaded;
        callback && callback(`${script} loaded failed, ${e}`);
    };
};
